import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { DataService } from '../../shared-service/data.service';


@Injectable()
export class MyLearningService {
	public courseGamficationPoints: string = '';

	subjectToBeObserved!: BehaviorSubject<Object>;
	currentValue: any;
	RedirectTo: string = "";
	public isFromLearningSummary!: boolean;

	constructor(private ds: DataService) {
	}


	setObservableValue(val: Object) {
		this.subjectToBeObserved = new BehaviorSubject<object>(val);
		this.currentValue = this.subjectToBeObserved.asObservable();
	}

	changeValue(message: object) {
		this.subjectToBeObserved.next(message)
	}

	updateStoreData(key: PropertyKey, data: Object) {
		return this.ds.setStoreData(key, data);
	}

	getStoreData(key: PropertyKey) {
		return this.ds.getDataStoreData(key);
	}

	getLearningListFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'learning/GetMyLearnings';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}
	getAllLearningListFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'learning/GetViewAllMyLearnings';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}

	getReadAndSignLearningsListFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'learning/GetReadAndSignLearnings';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}

	getPendingLearningListFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'learning/GetPendingForApprovalLearnings';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}

	getSummaryFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'learning/GetMyLearningSummary';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}

	getTrainingHistorySummaryFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'learning/GetTrainingHistorySummary';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	};

	getExternalLearningTypes(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'learning/GetExternalLearningTypes', body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}

	getExternalLearningDetails(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'learning/GetExternalLearningDetails', body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}

	getTrainingHistoryListFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'learning/GetMyTrainingHistory';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => { reject(err); });
		});
	}

	getLearningCalendarData(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'learning/GetMyLearningCalender';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				if (this.getStoreData('calView') == false) {
					this.ds.dataStore['calView'] = 'month';
				}
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}

	getLearningCalendarOngoingTasks(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'learning/GetMyLearningCalenderOngoing';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}

	getMyAcheivementsSummaryFromServer(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'learning/GetMyAcheivementsSummary';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}
}
